import { UnionServiceDelegation } from "../../Model/UnionServiceDelegation/UnionServiceDelegation";

export class GetUnionDelegationServiceList {
    constructor(
        total,
        offset,
        limit,
        records
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetUnionDelegationServiceList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((record) => {
                return UnionServiceDelegation.createFromResponseData(record);
            }),
        );
    }
}